import React from 'react';
import './Modal.css';

export default function Modal({ children, onClose }) {
    return (
        <div className="modalOverlay" onClick={() => onClose()}>
            <div className="modalContent" onClick={(e) => e.stopPropagation()}>
                <div className="closeButton" onClick={() => onClose()}>&times;</div>
                {children}
            </div>
        </div>
    );
}
